export default "__VITE_ASSET__DBWud2JD__"